import { MANIFESTO } from "../../data";
import { Reveal } from "./Reveal";

export const Manifesto = () => (
  <section id="approach" data-testid="manifesto-section" className="relative py-24 md:py-32 bg-[#0a192f] border-y border-[#bf953f]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">How We Protect</p>
        <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white max-w-3xl">
          Our approach is a <span className="text-gold-gradient italic">promise</span>, not a pitch.
        </h2>
      </Reveal>

      <div className="mt-16 flex flex-col">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.08}>
            <div
              data-testid={`manifesto-chapter-${m.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-t border-white/10 py-10 md:py-14 hover:border-[#bf953f]/40 transition-colors duration-500"
            >
              <div className="md:col-span-3">
                <span className="font-serif-display text-6xl md:text-8xl text-white/10 group-hover:text-gold-gradient transition-colors duration-500">
                  {m.n}
                </span>
              </div>
              <div className="md:col-span-9 md:pt-3">
                <h3 className="font-serif-display text-3xl md:text-4xl font-medium text-white">{m.title}</h3>
                <p className="mt-4 max-w-2xl font-body font-light text-base md:text-lg leading-relaxed text-white/60">
                  {m.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
